import React from "react";
import { STRINGS } from "../../strings";
import { translate } from "../../translate";
import AnimatedModal from "../AnimatedModal";
import { AppButton } from "../Generic/AppButton";
import { default as WomanSearchingFilesVectore } from "/public/assets/woman-searching-files.svg?react";
import Flex from "../Generic/Flex";

export interface PromptMissingFilesModalProps {
  isOpen: boolean;
  onRequestClose: () => void;
  onRequestPatientRefusedVisit: () => void;
}

function PromptMissingFilesModal(props: PromptMissingFilesModalProps) {
  const actions = (
    <Flex direction="column" gap={4}>
      <AppButton variant="filled" color="primary" onClick={props.onRequestClose}>
        {translate(STRINGS.OK)}
      </AppButton>
      <AppButton variant="outline" color="primary" onClick={props.onRequestPatientRefusedVisit}>
        {translate(STRINGS.PATIENT_IS_NOT_HOME)}
      </AppButton>
    </Flex>
  );

  return (
    <AnimatedModal
      headline={translate(STRINGS.ARENT_YOU_MISSING_SOMETHING)}
      message={translate(STRINGS.YOU_NEED_TO_SUBMIT_YOUR_DOCUMENTS_BEFORE_CLOCK_OUT)}
      animation={<WomanSearchingFilesVectore width={"300px"} height={"auto"} />}
      animationOffset={100}
      actions={actions}
      isOpen={props.isOpen}
      onRequestClose={props.onRequestClose}
    />
  );
}

export default PromptMissingFilesModal;
